<template>
    <div class="container">
        <div class="top">
            当前订单状态：{{orderStatus.get(orderDetail.order_status)}}
        </div>
		<div class="log">
			<div class="title">交易日志</div>
			<div style="display: block;text-align:left;margin-left:50px">
				<el-timeline>
					<el-timeline-item
						v-for="(item, index) in OrderLog"
						:key="index"
						:timestamp="item.add_time">
						{{item.msg}}
					</el-timeline-item>
				</el-timeline>
			</div>
		</div>
        <div class="middle">
            <div class="title">
                商品信息
            </div>
            <table>
                <th>
                    <td>药品名称/规格</td>
                    <td>生产厂家</td>
                    <td>单价</td>
                    <td>数量</td>
                    <td>小计</td>
                </th>
                <tr v-for="(item, i) in orderDetail.goods_info" :key="i">
                    <td>
                        <img :src="spliceImg(item.original_img)"/>
                        {{item.goods_name}}
                        <br />
                        {{item.goods_spec}}
                    </td>
                    <td>{{item.manufacturer_name}}</td>
                    <td>{{item.shop_price}}</td>
                    <td>{{item.goods_num}}</td>
                    <td>{{item.pay_price}}</td>
                </tr>
            </table>
            <div class="price">
                <div class="left">
                    <div class="left_left">订单备注：</div>
                    <div class="left_right">{{orderDetail.user_note}}</div>
                </div>
                <div class="right">
                    <div class="right_field">
                        <div class="field_name">总价</div>
                        <div class="field_value">￥{{orderDetail.total_amount}}</div>
                    </div>
                    <div class="right_field">
                        <div class="field_name">实付款</div>
                        <div class="field_value">￥{{orderDetail.order_amount}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bottom">
            <div class="title">
                交易信息
            </div>
            <div class="order_field" style="width: 100%">
                订单编号：{{orderDetail.order_sn}}
            </div>
            <div class="order_field">
                交易时间：{{orderDetail.add_time}}
            </div>
            <div class="order_field">
                付款时间：{{orderDetail.pay_time}}
            </div>
            <div class="order_field">
                付款方式：{{orderDetail.pay_type === 1 ? '预付款' : '普通付款'}}
            </div>
            <div class="order_field">
                付款渠道：{{payWay.get(orderDetail.pay_way)}}
            </div>
            <div class="order_field">
                发货时间：{{orderDetail.shipping_name}}
            </div>
            <div class="order_field">
                快递名称：{{orderDetail.shipping_name}}
            </div>
            <div class="order_field">
                快递单号：{{orderDetail.shipping_sn}}
            </div>
            <div class="order_field">
                退款金额：{{orderDetail.return_price}}
            </div>
        </div>
    </div>
</template>

<script>
	const payWay = new Map([
		['wx', '微信'],
		['ali', '支付宝'],
		['other', '其他'],
	]);
	const orderStatus = new Map([
		[0, '未付款'],
		[2, '已付款'],
		[3, '发货中'],
		[4, '订单完成'],
		[6, '退货中'],
		[7, '退款中'],
		[8, '退款完成'],
		[9, '付款中'],
		[-1, '订单关闭/订单过期'],
	]);
	import { OrderService } from '../../service/order.service';

	export default {
		name: 'orderDetail',
		data() {
			return {
				payWay,
				visible: false,
				orderStatus,
				orderDetail: {},
				OrderLog:[],
			}
		},
		created(){
			if(this.$route.query.data){
				OrderService.detail(this.$route.query.data).then(res=>{
					this.orderDetail = res.detail;
					this.OrderLog = res.log
				})
			}
		},
		methods: {
			open(item) {
				this.orderDetail = item;
				this.visible = true;
			},
			handleClose() {
				this.visible = false;
			},
			spliceImg(imgStr = '') {
				const url = 'https://api.goodyiyao.cn/';
				return imgStr.match(/^http|https/) ? imgStr : (url + imgStr);
			},
		}
  	}
</script>

<style lang="scss" scoped>
	.container {
		background:#fff;
		margin: 20px;
		.top {
			border: 1px solid #aaa;
			padding: 10px 20px;
			font-weight: bold;
			display: flex;
			align-items: center;
		}
		.middle {
			border: 1px solid #aaa;
			margin: 10px 0;
			padding: 10px;
			box-sizing: border-box;
			width: 100%;
			table {
				display: table;
				width: 100%;
				margin-top: 10px;
				th {
					display: table-header-group;
					td {
						width: 16%;
						display: table-cell;
						vertical-align: middle;
						&:first-child {
							width: 36%;
						}
					}
				}
				tr {
					td {
						&:first-child {
							img {
								height: 50px;
								width: 60px;
							}
						}
					}
				}
			}
		}
		.title {
			padding-left: 20px;
			position: relative;
			margin-left: 10px;
			&::before {
				content: ' ';
				background: #1d90d0;
				width: 4px;
				position: absolute;
				left: 0;
				height: 100%;
			}
		}
	}
	.price {
		display: flex;
		.left {
			flex: 1;
			display: flex;
			&_left {
				font-weight: bold;
			}
		}
		.right {
			flex: 1;
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			&_field {
				width: 200px;
				display: flex;
				justify-content: space-between;
				.field_name {
					font-weight: bold;
				}
				.field_value {
					color: red;
				}
			}
		}
	}
	.bottom {
		display: inline-block;
		border: 1px solid #aaa;
		width: 100%;
		box-sizing: border-box;
		padding: 10px;
		.order_field {
			font-weight: bold;
			width: 25%;
			white-space: nowrap;
			margin: 10px 0;
			font-size: 12px;
			float: left;
		}
	}
	.log {
		margin-top: 10px;
		display: block;
		border: 1px solid #aaa;
		width: 100%;
		box-sizing: border-box;
	}
</style>